import { action, makeObservable, observable } from 'mobx';
import { parseJwt } from '../utils';

class UserStore {

  id: string = '';
  balance: number = 0;
  currency: string = 'FUN';
  accessToken: string = '';
  playerExternalId: string = '111111';
  lastWin: number | null = null;
  lastWinClone: number | null = null;

  constructor() {
    makeObservable(this, {
      playerExternalId: observable,
      balance: observable,
      lastWin: observable,
      setPlayerExternalId: action,
      setBalance: action,
      setLastWin: action,
    })
  }

  setId = (id: string) => {
    this.id = id;
  }

  setPlayerExternalId = (id: string) => {
    this.playerExternalId = id;
  }

  setBalance = (balance: number) => {
    this.balance = balance;
  }

  setLastWin = (lastWin: number | null) => {
    this.lastWin = lastWin;
    if (lastWin) {
      this.lastWinClone = lastWin;
    }
  }

  setCurrency = (currency: string) => {
    this.currency = currency;
  }

  setAccessToken = (accessToken: string) => {
    this.accessToken = accessToken;
    if (accessToken)
      this.setUserDataFromToken();
  }

  private setUserDataFromToken = () => {
    const payload = parseJwt(this.accessToken);
    this.setId(payload.sub);
    this.setCurrency(payload.currency);
    this.setPlayerExternalId(payload.playerExternalId);
  }

}

export const userStore = new UserStore();
